import {create} from "zustand";
import {persist} from "zustand/middleware";

export const useNavigationStore = create(persist((set) => ({
    profileSelected: 1,
    titleProfile: 'Личные данные',

    onChangeNavigation: (el) => set({
        profileSelected: el.id,
        titleProfile: el.title,
    }),
}), {name: 'profile'}));
